import axios from 'axios'

const API_URLS = process.env.REACT_APP_API_URLS

export const getListProduct = async (search?: any, page?: any) => {
  let url = `${API_URLS}/products?populate=*&`
  if (page) url += `pagination[pageSize]=5&pagination[page]=${page}&`
  if (search) url += `_q=${search}&`
  try {
    const response = await axios.get(url)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getListProducts = async () => {
  let url = `${API_URLS}/products?populate=*&`
  try {
    const response = await axios.get(url)
    const allProducts = response.data.data.map((e: any) => ({
      label: e.attributes.name,
      value: e.id,
    }))
    return Promise.resolve(allProducts)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getDepartment = async () => {
  let url = `${API_URLS}/departments`
  try {
    const response = await axios.get(url)
    const allDepartment = response.data.data.map((e: any) => ({
      label: e.attributes.name,
      value: e.id,
      budget: e.attributes.annual_budget,
    }))
    return Promise.resolve(allDepartment)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getcustomerState = async () => {
  let url = `${API_URLS}/self-cares?populate=*`
  try {
    const response = await axios.get(url)
    const allcustomerState = response.data.data.map((e: any) => ({
      label: e.attributes.name,
      value: e.id,
    }))
    return Promise.resolve(allcustomerState)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getDetailProduct = async (id: any) => {
  let url = `${API_URLS}/products/${id}?populate=*`
  try {
    const response = await axios.get(url)
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const postProduct = async (datas: any) => {
  try {
    const file = new FormData()

    for (let i = 0; i < datas.images.length; i++) {
      file.append(`files`, datas.images[i].path)
    }
    const responseUpload = await axios.post(`${API_URLS}/upload`, file)
    const idImage = responseUpload.data.map((e: any) => e.id)
    if (responseUpload.status == 200) {
      var data = {
        description: datas.description,
        image: idImage,
        url: datas.link,
        name: datas.name,
        point: datas.point,
        product_detail: datas.product_detail,
        sku: datas.sku,
        transaction_value: datas.transaction_value,
        globalPercent: datas.globalPercents,
        percent: datas.parcent,
      }
      const response = await axios.post<any>(`${API_URLS}/products`, {
        data: data,
      })
      return Promise.resolve(response.data.data)
    }
  } catch (error) {
    return Promise.reject(error)
  }
}

export const deleteProductsById = async (id: any) => {
  try {
    const response = await axios.delete(`${API_URLS}/products/${id}`)
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const putProduct = async (datas: any) => {
  try {
    var data = {
      description: datas.form.description,
      url: datas.form.link,
      name: datas.form.name,
      point: datas.form.point,
      product_detail: datas.form.product_detail,
      sku: datas.form.sku,
      transaction_value: datas.form.transaction_value,
      globalPercent: datas.form.globalPercents,
      percent: datas.form.parcent,
      personas: datas.form?.personas,
    }
    const response = await axios.put<any>(`${API_URLS}/products/${datas.id}`, {
      data: data,
    })
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}
